import { render, staticRenderFns } from "./Warnings.vue?vue&type=template&id=63caebe2&scoped=true&"
import script from "./Warnings.vue?vue&type=script&lang=ts&"
export * from "./Warnings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63caebe2",
  null
  
)

export default component.exports